import { MotionSource } from '../../motion/MotionSource';
import { getCSSVarValue } from '../../utils';

export const drawSoundwave = (
  ctx: CanvasRenderingContext2D,
  buffer: AudioBuffer,
  width: number,
  height: number
) => {
  const numChannels = buffer.numberOfChannels;
  const leftChannel = buffer.getChannelData(0);
  const rightChannel =
    numChannels > 1 ? buffer.getChannelData(1) : new Float32Array([]);
  const length = leftChannel.length;

  ctx.save();
  ctx.globalAlpha = 0.3;
  ctx.clearRect(0, 0, width, height);
  ctx.strokeStyle = getCSSVarValue('--secondary-text-color');

  ctx.translate(0, height / 2);

  const RESOLUTION = 10;

  for (var x = 0; x < width; x++) {
    for (var i = 0; i < RESOLUTION; i++) {
      const index = Math.round(
        ((x * RESOLUTION + i) / (width * RESOLUTION)) * (length - 1)
      );
      var v = leftChannel[index];
      if (numChannels > 1) {
        v += rightChannel[index];
        v *= 0.5;
      }
      var h = (v * height) / 2;
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x, h);
      ctx.stroke();
    }
  }
  ctx.restore();
};

export const drawMotionSource = (
  ctx: CanvasRenderingContext2D,
  motionSource: MotionSource,
  width: number,
  height: number
) => {
  const totalDuration = motionSource.getDuration();
  ctx.save();
  ctx.globalAlpha = 0.3;
  ctx.clearRect(0, 0, width, height);
  ctx.strokeStyle = getCSSVarValue('--secondary-text-color');
  const lineWidth = 0.5;
  ctx.lineWidth = 0.5;
  for (var x = 0; x < width; x += lineWidth) {
    const pos = x / width;
    const level = motionSource.getLevelAt(pos * totalDuration);
    const h = height * level;
    ctx.beginPath();
    ctx.moveTo(x, height - h);
    ctx.lineTo(x, height);
    ctx.stroke();
  }
  ctx.restore();
};



// WEBPACK FOOTER //
// ./src/controller/utils/index.ts